import axiosPublic from 'utils/axiosPublic';

/** Paths match `router.get("/terms", ...)` when that router is mounted under `/api`. Adjust if your server mounts these elsewhere. */
export const PUBLIC_CMS_API = {
  terms: '/terms',
  privacyPolicy: '/privacy-policy',
  about: '/about',
  faq: '/faq'
} as const;

const HTML_KEYS = ['html', 'content', 'body'] as const;

function pickHtmlFromRecord(record: Record<string, unknown>): string {
  for (const key of HTML_KEYS) {
    const value = record[key];
    if (typeof value === 'string') return value;
  }
  return '';
}

function extractHtml(payload: unknown): string {
  if (payload == null) return '';
  if (typeof payload === 'string') return payload;
  if (typeof payload !== 'object') return '';

  const root = payload as Record<string, unknown>;
  const fromRoot = pickHtmlFromRecord(root);
  if (fromRoot) return fromRoot;

  const inner = root.data;
  if (typeof inner === 'string') return inner;
  if (inner && typeof inner === 'object') {
    return pickHtmlFromRecord(inner as Record<string, unknown>);
  }

  return '';
}

export async function fetchPublicHtml(relativePath: string): Promise<string> {
  const response = await axiosPublic.get<string>(relativePath, { responseType: 'text' });
  const raw = response.data;
  if (typeof raw !== 'string') return extractHtml(raw);

  const trimmed = raw.trim();
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    try {
      return extractHtml(JSON.parse(trimmed));
    } catch {
      return raw;
    }
  }

  return raw;
}
